import type { InstructionFilter } from './types';

export const INSTRUCTION_FILTERS: InstructionFilter[] = [
  { label: 'All', value: 'all' },
  { label: 'Global', value: 'global' },
  { label: 'Human Hand-off', value: 'escalation' }
];

export const INSTRUCTION_ACTIONS = {
  SEND_EMAIL: 'KIM_SEND_EMAIL',
  PRIVATE_NOTE: 'KIM_SEND_PRIVATE_NOTE',
  ASSIGN: 'KIM_ASSIGN',
  UNASSIGN: 'KIM_UNASSIGN',
  SEND_SLACK_MESSAGE: 'KIM_SEND_SLACK_MESSAGE'
} as const;

/** The Assign to User saved before Assign had targets: read as an Assign to Agent, never written. */
export const LEGACY_ASSIGN_TO_HUMAN = 'KIM_ASSIGN_TO_HUMAN';

/** Each instruction action is one escalation type of the brand's escalation policy. */
export const ACTION_POLICY_TYPE = {
  KIM_SEND_EMAIL: 'send-email',
  KIM_SEND_PRIVATE_NOTE: 'send-private-note',
  KIM_ASSIGN: 'assign',
  KIM_UNASSIGN: 'unassign',
  KIM_SEND_SLACK_MESSAGE: 'send-slack-message'
} as const;

export type InstructionActionType = typeof INSTRUCTION_ACTIONS[keyof typeof INSTRUCTION_ACTIONS];

// The escalation composers open on these; the protocol editor fills the same starting text.
export const EMAIL_SUBJECT_TEMPLATE = 'Esclation - {{TICKET_ID}}';
export const EMAIL_BODY_TEMPLATE = `Hi ,

[ADD MESSAGE HERE]

ADDITIONAL INFORMATION
URL: {{TICKET_URL}}
CONTEXT: {{CONTEXT}}

Thanks,
Kim AI

NOTE: any issues contact support@kim.cc`;

export const PRIVATE_NOTE_TEMPLATE = `Hi, 

This ticket has been Esclated. 

CONTEXT: {{CONTEXT}}

Thanks,
Kim AI`;
